module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"stbserial":"Set-Top Box Serial Number","multiple numbers possible":"multiple numbers possible"},"de":{"stbserial":"Set-Top Box Serial Nummer","multiple numbers possible":"mehrere Nummern möglich"}}')
  delete Component.options._Ctor
}
